import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import ReactGA from 'react-ga'
import { hotjar } from 'react-hotjar'
import 'react-datepicker/dist/react-datepicker.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import App from './App'

const {
  REACT_APP_ENV,
  REACT_APP_GA,
  REACT_APP_HJSV,
  REACT_APP_HJID,
  REACT_APP_SENTRY_DSN
} = process.env

const isProduction = REACT_APP_ENV === 'production'

if (isProduction && REACT_APP_GA) {
  console.log('google analytics initialize...')
  ReactGA.initialize(REACT_APP_GA)
}

if (isProduction && REACT_APP_HJSV && REACT_APP_HJID) {
  console.log('Hotjar initialize...')
  hotjar.initialize(REACT_APP_HJID, REACT_APP_HJSV)
}

if (REACT_APP_SENTRY_DSN) {
  Sentry.init({
    enabled: isProduction,
    dsn: REACT_APP_SENTRY_DSN
  })
}

ReactDOM.render(<App />, document.getElementById('root'))
